module.exports = __webpack_public_path__ + "media/images/default_avatar-5b7425c80da3a4cae3ec1a709bdcd4aa.jpeg";